import styled from 'styled-components'
import { mainColor } from '../../styles/global';
import { Link } from 'react-router-dom'

export const FooterWrapper = styled.footer`
    padding:3rem 7%;
    background:rgb(5, 9, 55);
    >div {
        img{
            height:100%;
            width:14%;
        }
    }
    >p{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 34px;
        margin:10px 0px;
        letter-spacing: 0.01em;
        color: #FFFFFF;
    }
    span{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 50px;
        text-align: justify;
        letter-spacing: 0.01em;
        color: #FFFFFF;
        display:block;
    }
    @media screen and (max-width: 768px) {
        height:fit-content;
        >div {
            img{
                height:100%;
                width:30%;
            }
        }
        p{
            font-weight: 500;
            font-size: 13px;
            line-height: 25px;
        }
        span{
            font-size: 10px;
            white-space: nowrap;
        }
    }

`;

export const QuickLinkWrapper = styled.div`
    display:grid;
    grid-template-columns:1fr 1fr 1fr 1fr;
    // place-items:center;
    gap:4rem;
    border-bottom: 2px solid rgba(0, 128, 128, 0.7);
    padding:20px 0 70px 0;
    ul > li > *{
        color:white;
        font-size:16px;
    }
    ul > li >p{
        color:white;
        font-size:12px;
        margin-top:8px;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns:1fr 1fr;
        gap:2rem;
        ul > li > *{
            color:white;
            font-size:12px;

        }
        ul > li{
            color:white;
            font-size:12px;

    
        }

    }
`;
export const NavLink = styled(Link)`
    color:#fff;
    text-decoration: none;
    font-family: 'Avenir';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    letter-spacing: 0.01em;

    @media screen and (max-width: 768px) {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 300;
        font-size: 11px;
        line-height: 37px;
        letter-spacing: 0.01em;
        color: #FFFFFF;
        
    }
  
`;

export const QuickLinkGrid = styled.div`
    ul{
        list-style: none;
    }
`;

export const LinkHeader = styled(Link)`
    font-family: 'Avenir';
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 50px;
    letter-spacing: 0.01em;
    color: #FFFFFF;
    text-decoration: none;

    @media screen and (max-width: 768px) {
        font-weight: 750;
        font-size: 15px;
        line-height: 37px;
    }
`;

export const SocialIcons = styled.ul`
    display:flex;
    // justify-content:space-between;
    gap:0.5rem;
`;


